/**
 * Extrae un mensaje de error legible del cuerpo JSON (`error.response.data`
 * de axios). Este cuerpo puede venir como `{ message }` (permisos, 401/404),
 * `{ message, errors }` (zod `.flatten()`) o `{ message, details: [{ message }] }`
 * en validaciones más específicas del backend; en ese último caso
 * `details[0].message` es más útil que el genérico. Si no hay nada
 * reconocible, se usa `fallback`.
 *
 * Reutilizar este helper en vez de duplicarlo por página (ya se copió
 * literal en `AppointmentSettings.tsx`, `Specialists.tsx` y `Services.tsx`
 * antes de extraerlo aquí).
 */
export function extractApiErrorMessage(err: unknown, fallback: string): string {
  const errData = (err as { response?: { data?: unknown } })?.response?.data;
  if (errData && typeof errData === "object") {
    const obj = errData as {
      message?: string;
      details?: { message?: string }[];
    };
    const firstDetail = Array.isArray(obj.details)
      ? obj.details.find((d) => typeof d?.message === "string" && d.message)
      : undefined;
    if (firstDetail?.message) return firstDetail.message;
    if (typeof obj.message === "string" && obj.message) return obj.message;
  }
  return fallback;
}
